import { Link } from "react-router-dom";
import heroImage from "../../../img/over/hero.webp?url";

export const EXAMPLE_LOCATION = "/location/5.94191,52.22936";

export const Hero = () => (
  <section className="mx-auto max-w-6xl px-4 py-4 sm:py-8">
    <div className="mx-auto max-w-3xl text-center">
      <div className="inline-flex items-center gap-2 rounded-full bg-white/70 px-3 py-1 text-xs font-medium text-emerald-800 ring-1 ring-emerald-100">
        <span className="h-2 w-2 rounded-full bg-emerald-600"></span>
        Bodematlas – perceelinzicht in minuten
      </div>

      <h1 className="mt-5 text-3xl font-extrabold tracking-tight sm:text-5xl">
        Voor elk perceel alle informatie over bodem en ontwikkeling
      </h1>

      <p className="mt-5 text-lg leading-relaxed text-slate-700">
        Bodematlas bundelt kadastrale, ruimtelijke, milieu- en marktinformatie per perceel in één
        rapport. Zoek percelen op kenmerken, bundel ze in projecten en stel je vragen aan een
        assistent die de regels én je eigen documenten kent.
      </p>

      <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
        <Link
          to={EXAMPLE_LOCATION}
          className="inline-flex items-center justify-center rounded-lg bg-emerald-700 px-5 py-3 text-sm font-semibold text-white hover:bg-emerald-800"
        >
          Start kavelanalyse
        </Link>
        <Link
          to="/login"
          className="inline-flex items-center justify-center rounded-lg border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-900 hover:bg-slate-50"
        >
          Maak een account
        </Link>
      </div>
    </div>

    <div className="mt-12 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl">
      <img
        src={heroImage}
        alt="Bodematlas met het perceelrapport van Koninklijk Park 15 in Apeldoorn naast de kaart"
        className="block w-full"
      />
    </div>
  </section>
);
